import {
  OccupationalAccidentInformation,
  TrafficAccidentInformation,
} from '../../../__generated__/api.ts'

export type AccidentDetailsFormData = {
  id: string
  required: boolean
  value: string
}

export interface DirectCompensationInformation {
  permitId?: string
  userFormData?: AccidentDetailsFormData[]
}

export type TrafficAccidentInformationFormType = {
  incidentDate?: Date
  incidentDescription: string
  vehicleRegistrationNumber: string
}

export type OccupationalAccidentInformationFormType = {
  incidentDate?: Date
  incidentDescription: string
  employer: string
}

export type InsuranceAdditionalDetailsType =
  | TrafficAccidentInformationFormType
  | OccupationalAccidentInformationFormType
  | DirectCompensationInformation

export const isOccupationalAccidentInformation = (
  details?: InsuranceAdditionalDetailsType
): details is OccupationalAccidentInformationFormType => {
  return (details as OccupationalAccidentInformationFormType)?.employer !== undefined
}

export const isTrafficAccidentInformation = (
  details?: InsuranceAdditionalDetailsType
): details is TrafficAccidentInformationFormType => {
  return (details as TrafficAccidentInformationFormType)?.vehicleRegistrationNumber !== undefined
}

export const isDirectCompensationInformation = (
  details?: InsuranceAdditionalDetailsType
): details is DirectCompensationInformation => {
  return (details as DirectCompensationInformation)?.permitId !== undefined
}
export const mapOccupationalAccidentInformation = (
  details: OccupationalAccidentInformationFormType
): OccupationalAccidentInformation => {
  return {
    incidentDate: details.incidentDate ? details.incidentDate.toJSON() : new Date().toJSON(),
    incidentDescription: details.incidentDescription,
    employer: details.employer,
  }
}

export const mapTrafficAccidentInformation = (
  details: TrafficAccidentInformationFormType
): TrafficAccidentInformation => {
  return {
    incidentDate: details.incidentDate ? details.incidentDate.toJSON() : new Date().toJSON(),
    incidentDescription: details.incidentDescription,
    vehicleRegistrationNumber: details.vehicleRegistrationNumber,
  }
}
